import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import CustomizedSnackbars from '../../components/material-snackbars';
import { withRouter } from 'react-router-dom';
import Api from '../../services/api';
import MyMaterialTable from '../../components/table/index-report';
import { AbilityContext } from '../../config/ability-context'
import { injectIntl } from 'react-intl';
import moment from "moment";
import { PapiroConsole } from '../../utils/papiroConsole';

class CalledOrganizationCategory extends Component {

    constructor(props) {
        super(props);

        const { userSession, calleds } = this.props;
        const { id } = this.props.match.params
        this.urlId = id
        this.isClient = true;

        userSession.user.userrole.map((item, key) => {
            if (item.role.roletype != 3) {
                this.isClient = false;
            }
        });

        this.state = {
            calledId: id ? id : calleds.called.id,
            loading: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            resultList: [],
        };

        this.closeNotification = this.closeNotification.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location.state === "reload") {
            this.componentDidMount();
        }
    }

    async componentDidMount() {
        await this.getItens();
    }

    async getItens() {
        const intl = this.props.intl;
        this.setState({ loading: true });
        await Api.get(`/performance/calledorganizationcategory/called/${this.state.calledId}/history`)
            .then(result => {
                if (result.data.success) {
                    PapiroConsole.log(result.data.data);
                    const formattedList = result.data.data.map(item => {
                        return {
                            id: item.id,
                            PreviousOrganizationCategoryName: item.previousorganizationcategory ? (item.previousorganizationcategory.parentname && item.previousorganizationcategory.parentname.length > 0 ? item.previousorganizationcategory.parentname : item.previousorganizationcategory.name) : '',
                            NextOrganizationCategoryName: item.nextorganizationcategory ? (item.nextorganizationcategory.parentname && item.nextorganizationcategory.parentname.length > 0 ? item.nextorganizationcategory.parentname : item.nextorganizationcategory.name) : '',
                            DateCreated: moment(item.createdat).format("DD/MM/YYYY HH:mm:ss"),
                            CreatedUserName: item.createduserdata ? item.createduserdata.name : ""
                        }
                    });

                    this.setState({ loading: false, resultList: formattedList });
                }
                else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                    Api.kickoff(result);
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    };

    closeNotification() {
        this.setState({ openNotification: false });
    }

    render() {
        const intl = this.props.intl;

        return (
            <>
                <MyMaterialTable
                    title={intl.formatMessage({ id: "called.organization.category.history.header" })}
                    columns={[
                        { title: intl.formatMessage({ id: "previous.organization.category" }), field: "PreviousOrganizationCategoryName" },
                        { title: intl.formatMessage({ id: "next.organization.category" }), field: "NextOrganizationCategoryName" },
                        { title: intl.formatMessage({ id: "date" }), field: 'DateCreated' },
                        { title: intl.formatMessage({ id: "user" }), field: 'CreatedUserName' }
                    ]}
                    data={this.state.resultList}
                />

                {this.state.loading && (
                    <Overlay>
                        <CircularProgress color='secondary' />
                    </Overlay>
                )}

                <CustomizedSnackbars
                    variant={this.state.notificationVariant}
                    message={this.state.notificationMessage}
                    isOpen={this.state.openNotification}
                    toClose={this.closeNotification}
                />
            </>
        );
    }
}
CalledOrganizationCategory.propTypes = {
    classes: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
    userSession: state.userSession,
    calleds: state.calleds,
});

export default injectIntl(withRouter(connect(mapStateToProps, null)(withStyles(Styles)(CalledOrganizationCategory))));

CalledOrganizationCategory.contextType = AbilityContext;
